/**
 * Rial Official - Minimal Card Instant Size Quick-Add
 * Bulletproof vanilla JavaScript handling 1-click variant add to cart
 */
(function () {
  'use strict';

  function initCardQuickAdd() {
    if (window._cardQuickAddInitialized) return;
    window._cardQuickAddInitialized = true;

    // Use capture phase so no parent link or script can intercept the click
    document.addEventListener(
      'click',
      async function (e) {
        const btn = e.target.closest('.quick-size-btn');
        if (!btn || btn.disabled || btn.classList.contains('is-loading')) return;

        // Stop link navigation and bubbling immediately
        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();

        const variantId = btn.getAttribute('data-variant-id');
        if (!variantId) return;

        btn.classList.add('is-loading');

        try {
          const cartNotification = document.querySelector('cart-notification');
          const cartDrawer = document.querySelector('cart-drawer');
          const activeCart = cartNotification || cartDrawer;

          const formData = new FormData();
          formData.append('id', variantId);
          formData.append('quantity', '1');

          if (activeCart && typeof activeCart.getSectionsToRender === 'function') {
            const sections = activeCart.getSectionsToRender().map((sec) => sec.id);
            formData.append('sections', sections.join(','));
            formData.append('sections_url', window.location.pathname);
            if (typeof activeCart.setActiveElement === 'function') {
              activeCart.setActiveElement(btn);
            }
          }

          const addUrl =
            window.routes && window.routes.cart_add_url
              ? window.routes.cart_add_url
              : '/cart/add.js';

          const response = await fetch(addUrl, {
            method: 'POST',
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
              Accept: 'application/json',
            },
            body: formData,
          });

          const data = await response.json();
          btn.classList.remove('is-loading');

          if (response.ok && !data.status) {
            btn.classList.add('is-added');
            setTimeout(() => btn.classList.remove('is-added'), 1800);

            if (window.publish && window.PUB_SUB_EVENTS) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'card-quick-add',
                productVariantId: variantId,
                cartData: data,
              });
            }

            if (activeCart && data.sections && typeof activeCart.renderContents === 'function') {
              activeCart.renderContents(data);
            } else if (activeCart && typeof activeCart.open === 'function') {
              activeCart.open();
            }

            // Always update cart count bubble badges directly
            try {
              const cartUrl =
                window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
              const cartRes = await fetch(cartUrl + '.js');
              const cart = await cartRes.json();
              document.querySelectorAll('.cart-count-bubble span:first-child').forEach((el) => {
                el.textContent = cart.item_count;
              });
              document.querySelectorAll('.cart-count-bubble').forEach((el) => {
                el.classList.remove('hidden');
              });
            } catch (_) {}
          } else {
            const msg =
              data.description ||
              data.message ||
              (data.errors ? JSON.stringify(data.errors) : 'Unable to add item to cart.');
            alert(msg);
          }
        } catch (err) {
          console.error('Error adding variant to cart:', err);
          btn.classList.remove('is-loading');
        }
      },
      true // capture phase ensures immediate interception before link default actions
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCardQuickAdd);
  } else {
    initCardQuickAdd();
  }
})();
